module.exports = __webpack_public_path__ + "img/case8.df509fd8.png";